import z from 'zod';
import { Currency } from '@/features/dashboard/paymentConfig/types/Currency.ts';
import { hasAgeRangeOverlap } from '@/schemas/ageRangeOverlapValidation.ts';

const ageRestrictionPriceSchema = z.object({
  name: z
    .string()
    .max(255, 'Nazwa może mieć maksymalnie 255 znaków')
    .optional(),
  minAge: z.coerce
    .number({ error: 'Wiek musi być liczbą' })
    .int({ error: 'Wiek musi być liczbą całkowitą' })
    .nonnegative('Wiek minimalny musi być większy lub równy 0'),
  maxAge: z.coerce
    .number({ error: 'Wiek musi być liczbą' })
    .int({ error: 'Wiek musi być liczbą całkowitą' })
    .positive('Wiek maksymalny musi być większy od 0'),
  price: z.coerce
    .number({ error: 'Cena musi być liczbą' })
    .nonnegative({ error: 'Cena musi być większa lub równa 0' }),
});

export const tourPricesSchema = z
  .object({
    currency: z
      .enum(Currency, { error: 'Waluta jest wymagana' })
      .default(Currency.PLN),
    price: z
      .number({ error: 'Cena musi być liczbą' })
      .nonnegative({ error: 'Cena musi być większa lub równa 0' })
      .default(0)
      .nullish(),
    priceName: z
      .string()
      .max(255, 'Nazwa może mieć maksymalnie 255 znaków')
      .optional(),
    isPriceByAge: z.boolean({ error: 'Pole wymagene' }),
    isVariantOnlyForDefinedAgeRanges: z.boolean({ error: 'Pole wymagane' }),
    ageRestrictionPrices: z.array(ageRestrictionPriceSchema),
  })
  .refine(
    (data) => {
      if (data.isVariantOnlyForDefinedAgeRanges) {
        return true;
      }
      return data.price != null && data.price >= 0;
    },
    {
      message: 'Cena musi być większa lub równa 0',
      path: ['price'],
    },
  )
  .refine(
    (data) => {
      if (!data.isPriceByAge || data.ageRestrictionPrices.length < 2) {
        return true;
      }
      return !hasAgeRangeOverlap(data.ageRestrictionPrices);
    },
    {
      message: 'Zakresy wiekowe nie mogą się nakładać',
      path: ['ageRestrictionPrices'],
    },
  );

export type BasePriceInputForm = z.input<typeof tourPricesSchema>;
export type BasePriceForm = z.infer<typeof tourPricesSchema>;
